import { InjectionToken } from '@angular/core';
import { Auth0Client } from '@auth0/auth0-spa-js';

import { environment } from '../../../environments/environment';

export type Auth0ClientInstance = Pick<
  Auth0Client,
  | 'loginWithRedirect'
  | 'logout'
  | 'getTokenSilently'
  | 'getIdTokenClaims'
  | 'handleRedirectCallback'
  | 'isAuthenticated'
>;

export const AUTH0_CLIENT = new InjectionToken<Auth0ClientInstance>('AUTH0_CLIENT', {
  providedIn: 'root',
  factory: () =>
    new Auth0Client({
      clientId: environment.authConfig.clientID,
      domain: environment.authConfig.domain,
      authorizationParams: {
        redirect_uri: window.location.origin
      },
      useRefreshTokens: true,
      useRefreshTokensFallback: true
    })
});
